export default __webpack_public_path__ + "656f30385f4293f0856a913f3dd3207b.gif";